import { SchemaField } from "shared/form/renderer/types/SchemaField";
import { ApiNonAttendeeRegistrationParticipant } from "shared/components/searchNonAttendeeRegistrationForm/types";
import { ApiFetchFieldsForViewType } from "shared/types/ApiFetchFieldsForViewType";
import CurrencyCode from "shared/enums/CurrencyCode";

export enum Action {
  SAVE_SEARCHED_NON_ATTENDEE_INFO = "SAVE_SEARCHED_NON_ATTENDEE_INFO"
}

export interface State {
  step: number;
  workEmail?: string;
  nonAttendeeParticipant?: ApiNonAttendeeRegistrationParticipant;
}
export interface ReducerDispatch {
  saveSearchedNonAttendeeInfo: (
    workEmail: string,
    nonAttendeeParticipant: ApiNonAttendeeRegistrationParticipant
  ) => void;
}

export type ActionType = {
  type: Action.SAVE_SEARCHED_NON_ATTENDEE_RESPONSE;
  data: { workEmail: string; nonAttendeeParticipant: ApiNonAttendeeRegistrationParticipant };
};

export interface AssignTicketService {
  state: State;
  assignFormSchema?: ApiFetchFieldsForViewType;
  dataUpdatedAt: number;
  assignTicketSchemaList: Array<SchemaField>;
  searchedNonAttendee?: ApiNonAttendeeRegistrationParticipant;
  submitHandler: (values: any) => void;
  searchSuccessHandler: (workEmail: string, regParticipantInfo: ApiNonAttendeeRegistrationParticipant) => void;
}

export interface SearchNonAttendeeRegistrationProps {
  service: AssignTicketService;
}

export interface AssignTicketProps {
  handleClose: () => void;
  initialState?: State;
  bulkTicketId: string;
  registrationId: string;
  eventSeriesId: string;
  currencyCode: CurrencyCode;
  registrationParticipantId: string;
  registrationName: string;
  assignTicketSuccessHandler: () => void;
  getValuesForSelfTransfer?: () => { email: string; nonAttendeeParticipant: { id: string } };
  canAssignTicketToSelf: boolean;
  ticketFormName?: string;
  ticketFormId: string;
  handleAssignTicketSuccess?: (toEmail: string) => void;
}

export interface AssignTicketCommonProps {
  handleClose: () => void;
  initialState?: State;
  bulkTicketId: string;
  ticketFormName?: string;
  ticketFormId: string;
}

export interface AssignTicketFormProps {
  formKey: string;
  disabled: boolean;
  schemaList: Array<SchemaField>;
  assignFormSchema?: ApiFetchFieldsForViewType;
  submitHandler: (values: any) => void;

  eventSeriesId: string;
  currencyCode: CurrencyCode;
  registrationId: string;
  registrationParticipantId: string;
}
